import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({
  allowedRoles, allowedModuleKey, role, modules, children,
}) {
  const hasRoleAccess = allowedRoles.includes(role);
  // console.log('Has Role Access:', hasRoleAccess);

  // If allowedModuleKey is provided, check for module access
  const hasModuleAccess = (() => {
    if (!allowedModuleKey) {
      return true;
    }

    const moduleEntry = modules?.[allowedModuleKey];
    const permissionKey = moduleEntry && typeof moduleEntry === 'object'
      ? Object.keys(moduleEntry)[0]
      : null;

    if (moduleEntry && permissionKey) {
      return moduleEntry[permissionKey] === true;
    }

    // Owners/Admins can access when module privileges are not provisioned yet
    if (role === 900 || role === 101) {
      return true;
    }

    return false;
  })();

  // console.log('Has Module Access:', hasModuleAccess);
  if (hasRoleAccess && hasModuleAccess) {
    return children;
  }

  return <Navigate to="/404" replace />;
}

export default ProtectedRoute;
